import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Studio from "@/pages/Studio";
import PaymentResult from "@/pages/PaymentResult";
import AuthCallback from "@/pages/AuthCallback";
import AdminLeads from "@/pages/AdminLeads";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import { initPixel } from "@/lib/pixel";

function Protected({ children }) {
    const { user, loading } = useApp();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">···</div>;
    if (!user) return <Navigate to="/auth" replace />;
    return children;
}

// Detect Emergent Google Auth callback (session_id in URL fragment) before any protected route runs.
function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/studio" element={<Protected><Studio /></Protected>} />
            <Route path="/admin/leads" element={<Protected><AdminLeads /></Protected>} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    useEffect(() => { initPixel(); }, []);
    return (
        <div className="App">
            <AppProvider>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
                <Toaster theme="dark" richColors position="top-right" offset={80} />
            </AppProvider>
        </div>
    );
}

export default App;
